import React, { Component } from 'react';
//import { PnkConnect } from '../pnk-react/pnk-miniredux';
import Facebook from "../assets/images/fb-icon.svg";
import TwitterIcon from "../assets/images/twitter-icon.svg";
import LinkedIn from "../assets/images/linkedin-icon.svg";
import WhatsApp from "../assets/images/whatsapp-icon.svg";
import Instagram from "../assets/images/insta-icon.svg";
import Youtube from "../assets/images/youtube-icon.svg";


import Logo from '../assets/images/kinship-logo.svg';

export default class Footer extends Component {
    // constructor(props) {
    //     super(props);
    // }


    render() {
        return (
            <div className="footer">
                <div className='container-fluid'>
                    <div className='footer-div'>
                        <div className='row'>
                            <div className='col-md-4 col-lg-6'>
                                <div className='footer-logo'>
                                    <img src={Logo} alt='loading...' />
                                    <p>&copy; 2022
                                    Kinship Living LLP. All rights reserved</p>
                                </div>
                                <div className='footer-privacy-div'>
                                    <p onClick={() => this.props.HandleRouting('privacy-policy')}>Privacy Policy</p>
                                    <p onClick={() => this.props.HandleRouting('terms-conditions')}>Terms & Conditions</p>
                                </div>
                            </div>
                            <div className='col-md-4 col-lg-3'>
                                <div className='footer-contact-us'>
                                    <h4>Contact with us</h4>
                                    <p>Write to us at</p>
                                    <a href='mailto:contactus@kinshipliving.com'>contactus@kinshipliving.com</a>
                                    <p>Call us on</p>
                                    <a href='tel:+918887757417'>
                                        +91-8887757417
                                    </a>
                                </div>
                            </div>
                            <div className='col-md-4 col-lg-3'>
                                <div className='footer-social-site'>
                                    <h4>Follow us on</h4>
                                    <div className='list-div'>
                                    <ul className='social-site-list'>
                                        <li> <a
                                            href="https://www.facebook.com/pinclickhomes"
                                            target="_blank"
                                        >
                                            <img src={Facebook} alt="loading..."/>
                                        </a></li>
                                        <li>
                                            <a
                                                href="https://twitter.com/pinclickhomes"
                                                target="_blank"
                                            >
                                                <img src={Instagram} alt="loading..." />
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="https://www.linkedin.com/company/10128393"
                                                target="_blank"
                                            >
                                                <img src={Youtube} alt="loading..." />
                                            </a>
                                        </li>
                                        </ul>
                                    <ul className='social-site-list'>
                                        <li>
                                        <a
                                        //    href="https://www.linkedin.com/company/10128393"
                                            target="_blank"
                                        >
                                            <img src={WhatsApp} alt="loading..." />
                                        </a>
                                    </li>
                                   
                                   
                                    <li>
                                            <a
                                                href="https://twitter.com/pinclickhomes"
                                                target="_blank"
                                            >
                                                <img src={TwitterIcon} alt="loading..." />
                                            </a>
                                        </li>
                                        <li>
                                        <a
                                            href="https://www.linkedin.com/company/10128393"
                                            target="_blank"
                                        >
                                            <img src={LinkedIn} alt="loading..." />
                                        </a>
                                    </li>
                                    </ul>
                                    </div>
        

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

